import { memo } from 'react'
import { safeButtonHaptic } from '../../lib/safeTelegram'

/**
 * Figma IconButton Component — круглые кнопки с иконками
 *
 * Props:
 * - icon: React element или путь к SVG
 * - onClick: обработчик клика
 * - disabled: отключена ли кнопка
 * - className: дополнительные классы
 *
 * Размеры из Figma:
 * - Размер: 38×38px
 * - Border radius: 50% (круг)
 * - Background: rgba(250,250,255,0.08)
 * - Icon size: 20×20px
 */

function IconButton({
  icon,
  onClick,
  disabled = false,
  className = '',
  ...props
}) {
  const handleClick = (e) => {
    if (disabled) return
    safeButtonHaptic()
    onClick?.(e)
  }

  const renderIcon = () => {
    if (typeof icon === 'string') {
      return (
        <img loading="eager"
          src={icon}
          alt=""
          width="20"
          height="20"
          className="h-5 w-5 object-contain"
          aria-hidden="true"
        />
      )
    }
    return icon
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`
        flex items-center justify-center
        h-[38px] w-[38px]
        rounded-full
        bg-[var(--figma-surface-08)]
        text-[var(--figma-text)]
        transition-all duration-[160ms]
        active:scale-[0.94]
        ${disabled ? 'opacity-46 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      {...props}
    >
      {renderIcon()}
    </button>
  )
}

export default memo(IconButton)
